import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
export var bigBlueStyle = {
  styles: /*#__PURE__*/_jsx(_JSXStyle, {
    id: "239317378",
    children: [".jsx-239317378{color:#21409A;font-size:1.25rem;}"]
  }),
  className: "jsx-239317378"
};
export var actionLinkStyle = {
  styles: /*#__PURE__*/_jsx(_JSXStyle, {
    id: "1715855886",
    children: [".jsx-1715855886{font-size:0.9375rem;font-weight:700;text-transform:uppercase;-webkit-text-decoration:none;text-decoration:none;color:#21409A;}", "a.jsx-1715855886:hover{-webkit-text-decoration:none;text-decoration:none;font-weight:700;}"]
  }),
  className: "jsx-1715855886"
};